module.exports = __webpack_public_path__ + "img/light_tip.a312a591.jpg";